import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';

function buildFallbackVersionText() {
  const buildTime = process.env.REACT_APP_BUILD_TIME || '';
  const gitSha = process.env.REACT_APP_GIT_SHA || '';
  if (buildTime && gitSha) {
    return `${buildTime} - ${gitSha}`;
  }
  return buildTime || gitSha || '';
}

/** 後台版本字串（優先後端 /getVersionInfo，失敗時用 build-time env） */
export function useVersionInfo() {
  const [versionText, setVersionText] = useState(buildFallbackVersionText);

  useEffect(() => {
    let cancelled = false;

    adminApi
      .getVersionInfo()
      .then((data) => {
        if (cancelled) {
          return;
        }
        const text = data != null ? String(data).trim() : '';
        if (text && !/^-+$/.test(text.replace(/\s/g, ''))) {
          setVersionText(text);
        }
      })
      .catch(() => {
        /* 保留 fallback */
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return versionText;
}
